<template lang="pug">
payment-order-block-form
  app-text-field( v-model="form.payer" label="Наименование плательщика" hideDetails dense :rules="[rules.required]" )
  app-text-field( v-model="form.payerInn" label="ИНН плательщика" hideDetails dense :rules="[rules.inn]")
  app-text-field( v-model="form.payerKpp" label="КПП плательщика" hideDetails dense :rules="[rules.required]" )
</template>

<script>
import PaymentOrderBlockForm from './PaymentOrderBlockForm.vue';
import { $_validate_rules } from '@/common/ValidateRules'

export default {
  mixins: [ $_validate_rules ],

  components: {
    PaymentOrderBlockForm
  },

  props: {
    form: null
  },
}
</script>